import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconVoiceCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVoiceCircle"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M3 14.5C12.25 -1.79758 13.9971 23.6551 21.2 14.5" stroke="currentColor" strokeLinejoin="round"/><Path d="M3.80908 16.4049C9.4295 12.3567 13 19.5 18 19.2501" stroke="currentColor" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconVoiceCircle;
